import React, { useEffect, useState } from 'react';
import { Flex, Button, VStack, Box } from '@chakra-ui/react';
import { FieldErrors, FieldValues, UseFormGetValues } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';

type EditGetInspiredProps = {
    errors: FieldErrors<FieldValues>;
    register: any;
    getValues: UseFormGetValues<any>;
};

const EditGetInspired: React.FC<EditGetInspiredProps> = ({ errors, register, getValues }) => {
    const [files, setFiles] = useState<File[]>([]);

    const handleRemove = (file: File) => {
        const data = getValues();
        setFiles(data['getInspiredFiles'])
        setFiles(files.filter((f) => f !== file));
    };
    const currProjectData: ProjectData = useSelector((state: RootState) => state.currProject.value);
    async function urlToFile(url: string): Promise<File> {
        const response = await fetch(url);
        const blob = await response.blob();
        const regex: RegExp = /%2F(.*?)-/;
        const match: RegExpExecArray | null = regex.exec(url);
        const fileName = (match && match[1]) ? match[1].replace(/%20/g, " ") : "NA";
        const file = new File([blob], fileName, { type: blob.type });
        return file;
    }

    useEffect(() => {
        Promise.all(currProjectData.inspireFiles.map((url, index) => urlToFile(url)))
            .then(filesArray => {
                setFiles(filesArray);
            })
            .catch(error => console.error('Error fetching files:', error));
    }, []);

    return (
        <Box>
            <Box sx={{fontSize: ['35px'], fontWeight: '800' }}>Get Inspired</Box>
            <Flex direction="column" alignItems="center">
                <Button
                    as={'label'}
                    htmlFor={'editGetInspiredFiles'}
                    variant={'outline'}
                    colorScheme={'teal'}
                    leftIcon={<i className='fas fa-cloud-upload-alt'></i>}
                    w='100%'
                >
                    Upload Files
                </Button>
                <input
                    id={'editGetInspiredFiles'}
                    type={'file'}
                    accept={'.jpg, .jpeg, .png, .pdf, .doc. .docx, .txt'}
                    style={{ display: 'none' }}
                    {...register('getInspiredFiles')}
                    multiple="multiple"
                    onChange={(e) => {
                        register('getInspiredFiles').onChange(e);  // React Hook Form's onChange
                        const newFiles = e.target.files!;
                        setFiles([...newFiles, ...files]);
                    }}
                />
                <VStack>
                    {files.map((file, idx) => (
                        <Box key={idx}>
                            {file.name}
                            <Button onClick={() => handleRemove(file)}>Remove</Button>
                        </Box>
                    ))}
                </VStack>
            </Flex>
        </Box>
    )
}

export default EditGetInspired